import { render } from "./Employee.vue?vue&type=template&id=e3eb9604&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"

import "./Employee.vue?vue&type=style&index=0&id=e3eb9604&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e3eb9604"

export default script